import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  dialogTitle: {
    color: theme.palette.blue_300.main
  },
  sectionTitle: {
    fontWeight: 500,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  emailRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    backgroundColor:
      theme.palette.type === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : 'rgba(0, 0, 0, 0.05)'
  },
  emailText: {
    flex: 1,
    wordBreak: 'break-all'
  },
  emailActions: {
    display: 'flex',
    alignItems: 'center'
  },
  addRow: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(1)
  },
  addButton: {
    marginBottom: theme.spacing(0.5)
  },
  disabledSection: {
    opacity: 0.5
  }
}))
